import { render, staticRenderFns } from "./WhitelabelRejectModal.vue?vue&type=template&id=6e485b94&"
import script from "./WhitelabelRejectModal.vue?vue&type=script&lang=js&"
export * from "./WhitelabelRejectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports